import * as types from './mutation-types'
import { storeClient } from '@/service/apiClients'
import versionHelp from '@Util/uiapp/versionHelp'

export default {
  async setStore ({ commit, state }, storeId) {
    if (!state.store || state.store.id !== storeId) {
      try {
        const { data: store } = await storeClient.get(`/stores/${storeId}/publicInfo`)
        commit(types.SET_STORE, store)
      } catch (e) {
        console.error('setStore connection error' + e)
      }
    }
  },
  async getTableNumbers ({ state, commit, getters }) {
    const { data: tableNumbers } = await storeClient.get(`stores/${getters.storeId}/tableNumbers`)
    commit(types.SET_TABLE_NUMBERS, tableNumbers)
  },
  setTableNumbers ({ commit }, tableNumbers) {
    commit(types.SET_TABLE_NUMBERS, tableNumbers)
    commit(types.SET_TABLE_NUMBER_DIRTY, true)
  },
  async asyncStoreData ({ rootGetters, commit }) {
    const { data: storeData } = await storeClient.get(`/stores/${rootGetters.storeId}`)
    commit(types.SET_STORE, storeData)
  },
  setStoreData ({ commit }, store) {
    commit(types.SET_STORE, store)
  },
  setSettings ({ commit }, settings) {
    commit(types.SET_SETTINGS, Object.assign({}, settings))
  },
  setFontSize ({ commit }, fontSize) {
    if (fontSize) {
      commit(types.SET_FONT_SIZE, fontSize)
    }
  },
  setMargin ({ commit }, margin) {
    if (margin) {
      commit(types.SET_MARGIN, margin)
    }
  },
  setPreOrderRing ({ commit }, ring) {
    commit(types.SET_PRE_ORDER_RING, ring)
  },
  setNewOrderRing ({ commit }, ring) {
    commit(types.SET_NEW_ORDER_RING, ring)
  },
  setFullscreen ({ commit }, fullscreen) {
    commit(types.SET_FULLSCREEN, fullscreen)
  },
  setNotification ({ commit }, notification) {
    commit(types.SET_NOTIFICATION, notification)
  },
  async checkAppVersion ({ commit }) {
    const { data: result } = await storeClient.get('/versions/storeManagement')
    if (!await versionHelp.isValidVersion(result.version)) {
      commit(types.SHOW_HASVERSION_DIALOG, result.version)
    }

    if (await versionHelp.isDetectedNewVersion()) {
      commit(types.SHOW_VERSION_DIALOG)
    } else {
      commit(types.SHOW_WELCOME_DIALOG)
    }
  }
}
